export { default as SafeAreaView } from './safe-area-view'
